"use client"

import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Slider.css";
import image1 from "../../assets/gladys_2.png";
import image2 from "../../assets/bruxismo_11.jpg";
import image3 from "../../assets/sueroterapia_2.jpg";

const slides = [
  {
    subtitle: "Collection 01",
    title: "Dra. Gladys Eugenia Quintero Capera",
    description: "Medicina Estetica",
    image: image1,
    link: "/nosotros" // Ruta de tu página existente
  },
  {
    subtitle: "Collection 02",
    title: "Bruxismo Enfoque en el Músculo Masetero",
    description: "Apretamiento dental inconsciente que genera dolor y desgaste. La sobreactividad del masetero es clave. Solución: Relajación muscular + prevención de daños. Recupera el equilibrio con un enfoque integral.",
    image: image2,
    link: "/servicios/bruxismo" // Ruta de tu otra página
  },
  {
    subtitle: "Collection 03",
    title: "Sueroterapia Regenerativa Medicamentos Biológicos Heel®",
    description: "Protocolo con cócteles bioreguladores para equilibrar funciones corporales, potenciar salud y calidad de vida. Beneficios: Restauración fisiológica + bienestar integral. Terapia innovadora para una vida en equilibrio.",
    image: image3,
    link: "/servicios/sueroterapia" // Ruta de tu tercera página
  },
];

const ImageSlider = () => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [allowScroll, setAllowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = (event) => {
      if (!allowScroll) {
        event.preventDefault();
        if (event.deltaY > 0) {
          if (currentSlide < slides.length - 1) {
            sliderRef.current.slickNext();
          } else {
            setAllowScroll(true);
            window.scrollTo({
              top: window.innerHeight,
              behavior: "smooth",
            });
          }
        } else {
          if (currentSlide > 0) {
            sliderRef.current.slickPrev();
          } else {
            setAllowScroll(false);
          }
        }
      } else {
        if (window.scrollY === 0 && event.deltaY < 0) {
          setAllowScroll(false);
        }
      }
    };

    window.addEventListener("wheel", handleScroll, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, [currentSlide, allowScroll]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    fade: false,
    arrows: true,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  return (
    <div className="slider-container">
      <Slider ref={sliderRef} {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="slider-item">
            <div className="image-section">
              <div className="orange-background"></div>
              <div className="image-container">
                <img src={slide.image || "/placeholder.svg"} alt={slide.title} />
              </div>
            </div>
            <div className="slide-content">
              <h3 className="slide-subtitle">{slide.subtitle}</h3>
              <h2 className="slide-title">{slide.title}</h2>
              <p className="slide-description">{slide.description}</p>
              <Link to={slide.link} className="slide-button">
                Leer mas 
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;